import { JOURNEY_PHASES, JourneyPhase } from '../shared/models/journey.models';

/**
 * Gamification layer of the onboarding journey.
 *
 * Levels and badges are *derived* from the phase each step carries: finishing a phase earns
 * its badge and raises the level by one. Nothing here is persisted, so the progression scheme
 * can be retuned without touching the API, the catalogue or the database.
 */

/** Badge icon awarded with each phase. */
export const JOURNEY_PHASE_ICONS: Record<JourneyPhase, string> = {
  discover: 'compass',
  understand: 'graduation-cap',
  reduce: 'leaf',
  engage: 'megaphone',
  review: 'target',
};

/** One badge per phase, so the top level is the number of phases. */
export const JOURNEY_MAX_LEVEL = JOURNEY_PHASES.length;
